import React from 'react';
import { Badge } from '@mui/material';

function GradientBadge({ index, loadonMap, i }) {
  return (
    <Badge
      badgeContent={index + 1}
      sx={{
        marginRight: '26px',
        marginTop: '10px',
        marginLeft: '10px',
        cursor: 'pointer',
        '& .MuiBadge-badge': {
          background: 'linear-gradient(135deg, black,#a0262b)',
          color: '#fff', // Text color
          fontSize: '14px',
          fontWeight: 'bold',
          borderRadius: '50%',
          border: '2px solid white', // Optional border
        },
      }}
      onClick={() => loadonMap(i)}
    />
  );
}

export default GradientBadge;
